export var alphabetStandardLowercase = "abcdefghijklmnopqrstuvwxyz";